import React from 'react';

const Footer = ({ config }) => {
  if (!config?.global_footer_text) return null;

  return (
    <footer className="text-center text-sm text-gray-600 py-8 bg-toon-yellow">
      <div className="max-w-4xl mx-auto">
        {config.global_footer_text}
        {config.terms_of_use_link && (
          <div className="mt-2">
            <a 
              href={config.terms_of_use_link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:underline"
            >
              Terms of Use
            </a>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
